<template>
    <div class="metro-box-wrapper">
        <div class="heading">
            <h3>Información de facturación</h3>
            <a data-toggle="modal" class="loginModal" href="#loginModal">¿Ya estás registrado en Vola Rooms? Login</a>
        </div>
        <div class="content">
            <div class="form-horizontal">
                <div class="form-group">
                    <label class="col-sm-4 col-md-2 control-label">Nombre</label>
                    <div class="col-sm-6 col-md-6">
                        <input type="text" class="form-control mb-0" placeholder="Nombre" name="firstname">
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-4 col-md-2 control-label">Apellidos</label>
                    <div class="col-sm-6 col-md-6">
                        <input type="text" class="form-control mb-0" placeholder="Apellidos" name="lastname">
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-4 col-md-2 control-label">Email</label>
                    <div class="col-sm-6 col-md-6">
                        <input type="email" class="form-control mb-0" placeholder="Email" name="email">
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-4 col-md-2 control-label">Dirección</label>
                    <div class="col-sm-6 col-md-6">
                        <input type="text" class="form-control mb-0" placeholder="Dirección">
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-4 col-md-6 control-label">Código Postal</label>
                    <div class="col-sm-6 col-md-6">
                        <input type="text" class="form-control mb-0" placeholder="Código Postal">
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-4 col-md-2 control-label">Ciudad</label>
                    <div class="col-sm-6 col-md-6">
                        <input type="text" class="form-control mb-0" placeholder="Ciudad">
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-4 col-md-2 control-label">Teléfono</label>
                    <div class="col-sm-6 col-md-6">
                        <input type="text" class="form-control mb-0" placeholder="Teléfono">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "billingForm"
    }
</script>

<style scoped>
    .loginModal {
        color: #8ac6c4 !important;
    }

    .loginModal:hover {
        color: #868686 !important;
    }
</style>